import { SpinnerLoader } from '@assets/icons'
import { Button, ErrorForm, HeaderPage, InputPassword } from '@components/index'
import { useYupValidation } from '@hooks/index'
import { IPasswordEdit } from '@interfaces/index'
import { errorHandler, ProfileService } from '@services/index'
import { editPasswordSchema } from '@yupSchemas/index'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

export default function EditPassword(): React.ReactElement {
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = React.useState(false)
    const [blockButtons, setBlockButtons] = React.useState(false)

    const {
        handleSubmit,
        control,
        formState: { errors },
    } = useForm<IPasswordEdit>({
        resolver: useYupValidation(editPasswordSchema),
    })

    async function submit(values: IPasswordEdit): Promise<void> {
        setIsLoading(true)
        setBlockButtons(true)
        try {
            const profileContext = await ProfileService.patchPasswordUser(values)
            toast(profileContext.message, { type: 'success' })
            navigate('/')
        } catch (err) {
            toast(errorHandler(err).message, { type: 'error' })
        } finally {
            setIsLoading(false)
            setBlockButtons(false)
        }
    }

    return (
        <div className="card">
            <div className="edit-password-wrapper">
                <HeaderPage title="Alteração de Senha" />

                <form className="pass-edit-user" onSubmit={handleSubmit(submit)}>
                    <div className="box-controller current-pass">
                        <Controller
                            name="currentPassword"
                            control={control}
                            defaultValue={''}
                            render={({ field: { value, onChange } }) => {
                                return (
                                    <InputPassword
                                        label="Senha atual"
                                        name="currentPassword"
                                        value={value}
                                        size='small'
                                        onChange={onChange}
                                    />
                                )
                            }}
                        />
                        <ErrorForm error={errors.currentPassword?.message} />
                    </div>

                    <div className="box-controller">
                        <Controller
                            name="newPassword"
                            control={control}
                            defaultValue={''}
                            render={({ field: { value, onChange } }) => {
                                return (
                                    <InputPassword
                                        label="Nova senha"
                                        name="newPassword"
                                        value={value}
                                        size='small'
                                        onChange={onChange}
                                    />
                                )
                            }}
                        />
                        <ErrorForm error={errors.newPassword?.message} />
                    </div>

                    <div className="box-controller">
                        <Controller
                            name="newPasswordConf"
                            control={control}
                            defaultValue={''}
                            render={({ field: { value, onChange } }) => {
                                return (
                                    <InputPassword
                                        label="Confirmação da nova senha"
                                        name="newPasswordConf"
                                        value={value}
                                        size='small'
                                        onChange={onChange}
                                    />
                                )
                            }}
                        />
                        <ErrorForm error={errors.newPasswordConf?.message} />
                    </div>

                    <div className="box-buttons">
                        <Button
                            secondary
                            placeholder="Cancelar"
                            type="button"
                            onClick={() => navigate(-1)}
                            isDisabled={blockButtons}
                        />

                        <Button
                            placeholder="Salvar"
                            type="submit"
                            isDisabled={blockButtons}
                        />
                    </div>
                </form>

                {isLoading ? (
                    <div className="loader-page">
                        <SpinnerLoader />
                    </div>
                ) : (
                    <></>
                )}
            </div>
        </div>
    )
}
